import React, { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { SbomServerModal } from '../application-reports/sbom-report/sbom-report-menu-item'
import { Tooltip } from '@contrast-security-inc/design-system-popovers'
import { IconReports } from '@contrast-security-inc/design-system-foundations'
import { IconButton } from '@contrast-security-inc/design-system-buttons'
import { css } from '@emotion/css'
import { useOrganizationFeature } from '../organization-feature'

export const testID = {
  reportsButton: 'reportsButton',
  cancelButton: 'cancelButton'
}

interface ServerReportsButtonProps {
  isFreemium: boolean
  organizationID: string
  serverID: string
}

enum SbomType {
  Application = 'applications',
  Server = 'servers'
}

export function ServerReportsButton({
  isFreemium,
  organizationID,
  serverID
}: ServerReportsButtonProps) {
  const { isLoading, enabled } = useOrganizationFeature(
    organizationID,
    'oss-inventory-mode'
  )
  const { formatMessage } = useIntl()
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const close = () => setIsOpen(false)
  return (
    <>
      {!isFreemium && (
        <Tooltip
          placement="top"
          className={css`
            z-index: 1003;
            padding: 0px 7px;
            line-height: 1.4px;
            font-size: 12px;
          `}
          body={<FormattedMessage id="title_reports" />}
        >
          <span>
            {!isLoading && enabled && (
              <IconButton
                Icon={IconReports}
                aria-label={formatMessage({ id: 'title_reports' })}
                onClick={() => setIsOpen(true)}
                data-testid={testID.reportsButton}
              />
            )}
            {
              <SbomServerModal
                closeModal={close}
                isOpen={isOpen}
                organizationID={organizationID}
                applicationID={serverID}
                sbomType={SbomType.Server}
              />
            }
          </span>
        </Tooltip>
      )}
    </>
  )
}
